module.exports = __webpack_public_path__ + "static/media/acoustic-cute.0466433c.mp3";